import { travelerApi as defaultTravelerApi } from "@b2bportal/traveler-api";
import type { ListTravelersResponse } from "@b2bportal/traveler-api/lib/api";
import { NETWORK_CALL_FAILED, type IApiConfig } from "@hopper-b2b/types";
import axios from "axios";
import { trackEvent } from "../tracking/trackEvent";

export const fetchTravelers = (
  apiConfig?: IApiConfig
): Promise<ListTravelersResponse> => {
  const travelerApi = defaultTravelerApi(axios);
  return new Promise((resolve, reject) => {
    travelerApi
      .apiV0TravelerListPut({})
      .then((response) => resolve(response.data))
      .catch((e) => {
        trackEvent(
          {
            eventName: NETWORK_CALL_FAILED,
            properties: {
              url: window.location.pathname,
            },
          },
          apiConfig
        );
        reject(e);
      });
  });
};
